'use strict';
import * as $j_app$002elocalization$002e$002dL18n$0024 from "./app.localization.-L18n$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_components_instances$package$$anon$6(x$1$12) {
  this.axo = null;
  this.axo = x$1$12;
}
export { $c_Lapp_components_instances$package$$anon$6 as $c_Lapp_components_instances$package$$anon$6 };
$p = $c_Lapp_components_instances$package$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_components_instances$package$$anon$6;
/** @constructor */
function $h_Lapp_components_instances$package$$anon$6() {
}
export { $h_Lapp_components_instances$package$$anon$6 as $h_Lapp_components_instances$package$$anon$6 };
$h_Lapp_components_instances$package$$anon$6.prototype = $p;
$p.bDR = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().fe($j_app$002elocalization$002e$002dL18n$0024.$m_Lapp_localization_L18n$().Yc.bD(this.axo));
});
var $d_Lapp_components_instances$package$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_components_instances$package$$anon$6, "app.components.instances$package$$anon$6", ({
  z3: 1,
  VI: 1
}));
export { $d_Lapp_components_instances$package$$anon$6 as $d_Lapp_components_instances$package$$anon$6 };
//# sourceMappingURL=app.components.instances$package$$anon$6.js.map
